module.exports = __webpack_public_path__ + "static/media/lender.e664b491.svg";